import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Loader from "../../Loader";
import Avvvatars from 'avvvatars-react';

export default function Favorit({ id, fav }) {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (fav && fav.length > 0) {
            setLoading(false);
        }
    }, [fav]);

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="adminx-content">
            <div className="adminx-main-content">
                <nav aria-label="chapelure" role="navigation">
                    <ol className="breadcrumb adminx-page-breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Accueil</Link></li>
                        <li className="breadcrumb-item"><Link to="#">Interface utilisateur</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Liste des favoris</li>
                    </ol>
                </nav>
                <br />
                <div className="section pt-0">
                    <div className="col-12">
                        <div className="card mb-grid">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <div className="card-header-title">Mes Favoris</div>
                            </div>
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Profil</th>
                                        <th scope="col">Poste</th>
                                        <th scope="col">Disponibilité</th>
                                        <th scope="col">Année d'expérience</th>
                                        <th scope="col">Localisation</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fav && fav.map(f => (
                                        <Favori key={f.cv_id} idCv={f.cv_id} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function Favori({ idCv }) {
    const [cv, setCv] = useState(null);
    const [cat, setCat] = useState(null);

    useEffect(() => {
        const fetchCvAndCategory = async () => {
            try {
                const cvResponse = await axios.get(`cvs/0${idCv}`);
                if (cvResponse.status === 200) {
                    const cvData = cvResponse.data.cv;
                    setCv(cvData);

                    if (cvData && cvData.categorie_cv_id) {
                        const catResponse = await axios.get(`categorie_cvs/${cvData.categorie_cv_id}`);
                        if (catResponse.status === 200) {
                            setCat(catResponse.data.cat);
                        }
                    }
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des données:", error);
            }
        };

        if (idCv) {
            fetchCvAndCategory();
        }
    }, [idCv]);

    if (!cv || !cat) {
        return null;
    }

    return (
        <tr>
            <td><Avvvatars size={50} value={cv.nomPrenom} /></td>
            <td>
                <Link to={`/cv/${cv.id}`} className="text-reset">
                    <strong>ID : 00{cv.id}</strong>
                </Link>
            </td>
            <td>{cat.categorie}</td>
            <td><span className="badge badge-success">{cv.disponibility}</span></td>
            <td>{cv.aExperience}</td>
            <td>{cv.nationalite}</td>
            <td>
                <div className="btn-group">
                    <Link to={`/cv/${cv.id}`} className="btn btn-info">Voir le CV</Link>
                </div>
            </td>
        </tr>
    );
}
